import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCoffee,
  faPlus,
  faCheck,
  faChevronDown,
  faChevronRight,
  faMinus,
  faMapMarkedAlt,
  faArrowRight,
  faArrowLeft,
  faCheckCircle,
  faHeart,
  faCar,
  faExclamation,
  faCreditCard,
  faMap,
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
import { faCircle} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faCoffee,
  faPlus,
  faCheck,
  faChevronDown,
  faChevronRight,
  faMinus,
  faMapMarkedAlt,
  faArrowRight,
  faArrowLeft,
  faCheckCircle,
  faCircle,
  faHeart,
  faCar,
  faExclamation,
  faCreditCard,
  faMap,
  faExclamationTriangle
)
export default FontAwesomeIcon;
